import { render, staticRenderFns } from "./rateindex.vue?vue&type=template&id=44336d1f&"
import script from "./rateindex.vue?vue&type=script&lang=js&"
export * from "./rateindex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports